import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppContext, SeoService } from './../../shared';

export abstract class BlogPage implements OnInit, AfterViewInit {
  title = 'Linescape Blog Page';
  description = 'Linescape';

  constructor(private route: ActivatedRoute, private app: AppContext, private seo: SeoService) {
  }

  ngOnInit() {
    this.seo.set(this.title, this.description);
  }

  ngAfterViewInit() {
    this.route.params.subscribe(params => {
      if (params['scroll'] != null && params['scroll'] === 'true') {
        window.scrollTo(0, 0);
      }
    });
  }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/press/blog-page/blog-page.component.ts